import script from "./StarRating.vue?vue&type=script&setup=true&lang=ts"
export * from "./StarRating.vue?vue&type=script&setup=true&lang=ts"

import "./StarRating.vue?vue&type=style&index=0&id=5ff39a2a&lang=scss"

const __exports__ = script;

export default __exports__